/*  eslint-disable array-callback-return */
import React from "react";

const MediumSubscription = (props) => {
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <React.Fragment>
            <div>
                <div className="subscription-frequent-header" >
                    {props.form.language.POPULAR_SUBSCRIPTION}
                </div>
            </div>
            <div
                className="subscription ewill subscription-container"
                style={{ borderRadius: "0 0 24px 24px", marginTop: 0 }}
            >
                <div className="subscription-content-container">
                    <div className="n_header-2">
                        {props.form.language.BETTER_SUBSCRIPTION}
                    </div>

                    <div className="momentio-home-tick n_header-4 subscription-desc">
                        <span></span>
                        <div className="subscription-content">
                            <div>{props.form.language.SUBSCRIPTION_SAFE}</div>
                            <div className="n_paragraph">{`${props.form.language.DASHBOARD_S25} 250`}</div>
                            <div className="n_paragraph">{`${props.form.language.DASHBOARD_S19} 250 / 1 Gb`}</div>
                        </div>
                    </div>
                    <div className="momentio-home-tick n_header-4 subscription-desc">
                        <span></span>
                        <div className="subscription-content">
                            <div>
                                {props.form.language.SUBSCRIPTION_MEMORIES}
                            </div>
                            <div className="n_paragraph">Max 50</div>
                        </div>
                    </div>
                    <div className="momentio-home-tick subscription-desc">
                        <span></span>
                        <div className="subscription-content">
                            <div>
                                {props.form.language.SUBSCRIPTION_LASTWISH}
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ textAlign: "center" }}>
                    <button
                        className="primary-button-blue"
                        onClick={() => {
                            props.addSubscriptionStep1(props.membership, 1);
                        }}
                    >
                        {props.form.language.SUBSCRIPTION_BETTER_BUTTON}
                    </button>
                    <div className="n_paragraph"  style={{ paddingTop: "10px" }}>
                        {`${props.form.language.ANNUAL_FEE} € ${parseInt(
                            props.membership.data.price
                        )}`}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default MediumSubscription;
